import { getPincode, setShippingAddress } from "@/components/cart/cartHelper"
import { store } from "@/store"
import { createCart, shipmentUpdate } from "@/store/features/cartSlice"
import { getProfile } from "@/store/features/checkoutSlice"

export const initBuyNow = atc => {
  const { auth = {}, cart = {} } = store.getState()
  const { user: { sub: email = "" } = {} } = auth
  const { cart: activeCart } = cart

  if (email) {
    store
      .dispatch(
        createCart({
          currency: "INR",
          customerEmail: email,
        })
      )
      .unwrap()
      .then(res => {
        window.localStorage.setItem("buy-now-init", true)
        window.localStorage.setItem("buy-now-cart", res.key)
        window.localStorage.setItem("active-cart", activeCart.id)
        window.localStorage.removeItem("regular-checkout")
        atc(setDefaultAddress)
      })
      .catch(ex => console.log(ex))
  }
}

const setDefaultAddress = () => {
  store
    .dispatch(getProfile())
    .unwrap()
    .then(async res => {
      try {
        const pincode = await getPincode()
        const { addresses = [], defaultShippingAddressId = "" } = res
        let address =
          addresses.find(
            item =>
              item.postalCode === pincode &&
              item.id === defaultShippingAddressId
          ) || addresses.find(item => item.postalCode === pincode)

        if (address) {
          if (!address.phone || address.phone === "") {
            const customPhone = res?.custom?.fields?.mobile
            address = { ...address, phone: customPhone }
          }
          const actions = await setShippingAddress(formatAddress(address))

          actions.push({
            action: "setBillingAddress",
            address: actions[0]?.address,
          })

          actions.push({
            action: "calculateTax",
          })

          await store.dispatch(shipmentUpdate({ actions }))
          redirectOneStepCheckout({ addrSet: true })
        } else {
          redirectOneStepCheckout({ addrSet: false })
        }
      } catch (ex) {
        console.log("Error in buy now step", ex)
      }
    })
}

const formatAddress = addr => {
  const address = JSON.parse(JSON.stringify(addr))
  address.custom = {
    fields: {
      label: "",
    },
    type: {
      typeId: "type",
      key: "custom-address",
    },
  }
  delete address.id
  return address
}

const redirectOneStepCheckout = ({ addrSet = true }) => {
  const formElem = document.createElement("form")
  const modeInputElem = document.createElement("input")
  const addrSetElem = document.createElement("input")

  formElem.method = "POST"
  formElem.action = "/checkout"
  formElem.style.display = "none"

  modeInputElem.type = "hidden"
  modeInputElem.name = "mode"
  modeInputElem.value = "one-step"

  addrSetElem.type = "hidden"
  addrSetElem.name = "addrSet"
  addrSetElem.value = addrSet

  formElem.appendChild(modeInputElem)
  formElem.appendChild(addrSetElem)

  document.body.appendChild(formElem)
  formElem.submit()
}

export function reorderImageData(arr, orderAttributeName = "order") {
  const newArr = [...arr]

  let elementToMoveIndex = -1
  let targetOrder = -1

  for (let i = 0; i < newArr.length; i++) {
    if (newArr[i].hasOwnProperty(orderAttributeName)) {
      elementToMoveIndex = i
      targetOrder = parseInt(newArr[i][orderAttributeName], 10) - 1
      break
    }
  }

  if (elementToMoveIndex === -1 || isNaN(targetOrder)) {
    return arr
  }

  const effectiveNewIndex = Math.max(
    0,
    Math.min(targetOrder, newArr.length - 1)
  )

  const [movedElement] = newArr.splice(elementToMoveIndex, 1)
  newArr.splice(effectiveNewIndex, 0, movedElement)

  return newArr
}
